
export default {
  name: 'PriceReveal',
  props: {
    // 价格值：Number/String。undefined/null/'' = 后端未授权（DTO 已剥字段），组件整体不存在
    value: { type: [Number, String], default: undefined },
    // 附属参考价（如划线原价）：与主值同属一个价格单元，跟随揭示
    secondary: { type: [Number, String], default: undefined },
    label: { type: String, default: '' },
    prefix: { type: String, default: '¥' }
  },
  data () {
    return { revealed: false } // 临时 UI 状态：离开页面/刷新/重进即回空白
  },
  watch: {
    // 价格单元变更（如详情页切换商品复用组件实例）＝新揭示会话，立即回空白
    value () {
      this.revealed = false
    }
  },
  computed: {
    hasValue () {
      return this.value !== undefined && this.value !== null && this.value !== ''
    },
    hasSecondary () {
      return this.secondary !== undefined && this.secondary !== null && this.secondary !== ''
    },
    display () {
      return this.prefix + this.value
    }
  }
}
